module.exports = __webpack_public_path__ + "static/media/lens3_grayzel.b7c3f181.png";